// extracted by mini-css-extract-plugin
export default {"atual":"ListaArtigos_atual__px84v","inativo":"ListaArtigos_inativo__gKiWa"};